import { h } from 'preact';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import RegisterStore from '@src/business-components/register/store';
import intl from 'react-intl-universal';
import SendCode from '@src/business-components/send-code';

import Button from '@src/components/button';
import _ from 'lodash';
import LoadingDiv from '@src/components/loading-div';
import SendCodeInput from '@src/components/send-code-input';
import FormItem from "@src/components/form-item";
import Form from "@src/components/form";
import Input from "@src/components/input";
import Checkbox from "@src/components/checkbox";
import "./index.less"
import {createRef, forwardRef} from "preact/compat";

const CreateForm = Form;

/**
 * 注册模块
 * @param className {string}
 * @param store {RegisterStore}
 * @param bottom {ComponentChildren}
 * @return {ComponentChildren}
 * @constructor
 */
const Register = forwardRef(({ className, store, bottom }, ref= createRef()) => {
  store.use();
  if (store.loadingStatus) {
    return (
      <div className={cx('xfe_common_register_root', className)} style={{ height: '300px' }}>
        <LoadingDiv />
      </div>
    );
  }
  return (
    <div className={cx('xfe_common_register_root', className)} ref={ref}>
      <CreateForm
        formRef={store.formRef}
        initialValue={store.formValue}
        onValuesChange={(props, changedValues, allValues) => {
          // console.log(props, changedValues, allValues);
          store.checkCodeValue(allValues);
          store.checkEmail(allValues.email);
        }}
      >
        <FormItem
          name="email"
          validateFirst={true}
          validateTrigger={'onBlur'}
          rules={[
            {
              required: true,
              message: intl.get('PAGE.REGISTER.EMAIL.INPUT.ERROR.EMPTY')
            },
            {
              validator: (rule, value, callback) => {
                if (/\s/.test(value)) {
                  callback(new Error(intl.get('PAGE.REGISTER.EMAIL.INPUT.ERROR.FORMAT')));
                }
                if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(_.trim(value))) {
                  callback(new Error(intl.get('PAGE.REGISTER.EMAIL.INPUT.ERROR.FORMAT')));
                } else {
                  callback();
                }
              }
            }
          ]}
        >
          <Input className={'xfe_common_register_input'} maxLength={50} placeholder={intl.get('PAGE.REGISTER.EMAIL.INPUT.PLACEHOLDER')} />
        </FormItem>
        <FormItem
          name="code"
          rules={[
            {
              required: true,
              whitespace: true,
              message: intl.get('PAGE.REGISTER.CAPTCHA.INPUT.ERROR.EMPTY')
            }
          ]}
        >
          <SendCodeInput
            className={"xfe_common_register_input"}
            placeholder={intl.get('PAGE.REGISTER.CAPTCHA.INPUT.PLACEHOLDER')}
            type={'text'}
            maxLength={6}
            suffix={
              <SendCode type={'primary'} disable={store.sendCodeDisable} onClick={store.beforeSendCode} countDown={60} className={'xfe_common_register_sendCode'}>
                {intl.get('PAGE.REGISTER.SEND_CODE.TEXT')}
              </SendCode>
            }
          />
        </FormItem>
        <FormItem
          name="password"
          validateTrigger={'onBlur'}
          rules={[
            {
              required: true,
              whitespace: true,
              message: intl.get('PAGE.REGISTER.PASSWORD.INPUT.ERROR.EMPTY')
            },
            {
              validator: (rule, value, callback) => {
                if (/\s/.test(value)) {
                  callback(new Error(intl.get('PASSWORD.INPUT.ERROR.BLANK')));
                }
                if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z][\s\S]{7,30}$/.test(_.trim(value))) {
                  callback(new Error(intl.get('PAGE.REGISTER.PASSWORD.INPUT.ERROR.FORMAT')));
                }
                callback();
              }
            }
          ]}
        >
          <Input className={'xfe_common_register_input'} type={'password'} maxLength={30} placeholder={intl.get('PAGE.REGISTER.PASSWORD.INPUT.PLACEHOLDER')} />
        </FormItem>
        <FormItem
          name="repeatPassword"
          validateTrigger={'onBlur'}
          rules={[
            {
              required: true,
              whitespace: true,
              message: intl.get('PAGE.REGISTER.REPEAT_PASSWORD.INPUT.ERROR.EMPTY')
            },
            {
              validator: (rule, value, callback) => {
                if (/\s/.test(value)) {
                  callback(new Error(intl.get('PASSWORD.INPUT.ERROR.BLANK')));
                }
                if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z][\s\S]{7,30}$/.test(_.trim(value))) {
                  callback(new Error(intl.get('PAGE.REGISTER.PASSWORD.INPUT.ERROR.FORMAT')));
                }
                const passwordValue = store.formRef.current.props.form.getFieldValue('password');
                if (_.trim(passwordValue) !== _.trim(value)) {
                  callback(new Error(intl.get('PAGE.REGISTER.REPEAT_PASSWORD.INPUT.ERROR.NOT_SAME_VALUE')));
                }
                callback();
              }
            }
          ]}
        >
          <Input className={'xfe_common_register_input'} type={'password'} maxLength={30} placeholder={intl.get('PAGE.REGISTER.REPEAT_PASSWORD.INPUT.PLACEHOLDER')} />
        </FormItem>
      </CreateForm>
      <Checkbox className={'xfe_common_register_protocol'} onChange={e => store.changeProtocolStatus(e.target.checked)}>
        {intl.getHTML('PAGE.REGISTER.PROTOCOL', {
          privacyLink: store.link.privacyAgreement,
          privacyName: intl.get('PAGE.REGISTER.PROTOCOL.PRIVACY_NAME'),
          userAgreementLink: store.link.userAgreement,
          userAgreementName: intl.get('PAGE.REGISTER.PROTOCOL.USER_AGREEMENT_NAME')
        })}
      </Checkbox>
      <div className={'xfe_common_register_btnBox'}>
        <Button onClick={store.registerHandle} type={store.submitBtnDisable ? 'disable' : ''} className={'xfe_common_register_btn'}>
          {intl.get('PAGE.REGISTER.SUBMIT.TEXT')}
        </Button>
      </div>
      {bottom}
    </div>
  );
});
export default wrapStore(Register, RegisterStore);
